import {Injectable} from '@angular/core';
import {Subject} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ClientListService {
  onMeasurementFilterChange = new Subject<{ isActive?: boolean }>();
  onGroupFilterChange = new Subject<any>();
  onAddMeasurementClick = new Subject<void>();
  onClinicFilterChange = new Subject<{
    orgType?: number[],
    status?: number[],
    search?: string,
  }>();
  onParticipantCaregiverFilterChange = new Subject<{
    clientId?: number[],
    groupId?: number[],
    role?: number[],
    status?: number[],
    searchText?: string,
  }>();

  onParticipantWeightInformationFilterChange = new Subject<{
    clientId?: number[],
    groupId?: number[],
    session?: number,
    status?: number[],
    searchText?: string,
  }>();

  onParticipantBehaviourInformationFilterChange = new Subject<{
    clientId?: number,
    groupId?: number,
    role?: number[],
    session?: number,
    status?: number[],
    searchText?: string,
  }>();

  constructor() {
  }
}
